import { useLocation } from 'react-router-dom';

const INFORMATION_ROUTES = ['success', 'rejected', 'error'];

export const useGetCheckoutRoutesVerification = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const isPaymentRoute = pathname.includes('/payment');

  const isPixRoute = pathname.includes('/pix');

  const isTicketsRoute = pathname.includes('/tickets');
  const isLoginRoute = pathname.includes('/login');

  const isAtAnyInformationRoute = INFORMATION_ROUTES.some(router =>
    pathname.includes(router),
  );

  const isAddCardRoute = pathname.includes('/add-card');
  const isConfirmCardRoute = pathname.includes('/confirm-card');
  const isPaymentMethodsRoute = pathname.includes('/payment-methods');

  const isCardRoute =
  isPaymentMethodsRoute || isAddCardRoute || isConfirmCardRoute;

  return {
    isPaymentRoute,
    isPixRoute,
    isAtAnyInformationRoute,
    isAddCardRoute,
    isConfirmCardRoute,
    isPaymentMethodsRoute,
    isCardRoute,
    isTicketsRoute,
    isLoginRoute
  };
};
